import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { useParams, Redirect } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import MdlSelectExam from "../dialog/MdlSelectExam";
import MdlPrintableSettings from "../dialog/MdlPrintableSettings";
import BackButton from "../ChildComponent/BackButton";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const PANEL_STYLE = {
  margin: "0 20px 20px",
  padding: "0",
};

const PAGE_TITLE_BAR_STYLE = {
  width: "100%",
  background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
  padding: "12px 18px",
  borderRadius: "8px 8px 0 0",
  boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
  marginTop: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
};

const PAGE_TITLE_STYLE = {
  fontSize: "20px",
  fontWeight: "700",
  color: "#fff",
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const PAGE_SUBTITLE_STYLE = {
  margin: "2px 0 0",
  fontSize: "11px",
  fontWeight: "600",
  color: "rgba(255, 255, 255, 0.88)",
};

const PANEL_BODY_STYLE = {
  padding: "14px 16px 20px",
  background: COLORS.white,
};

const STYLES = {
  titleActions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
  },
  titleBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    border: "2px solid rgba(255, 255, 255, 0.75)",
    borderRadius: "6px",
    padding: "7px 14px",
    fontSize: "12px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
    background: "rgba(255, 255, 255, 0.95)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 4px rgba(1, 87, 155, 0.2)",
  },
  titleBtnPrimary: {
    color: COLORS.white,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`,
    border: "2px solid rgba(255, 255, 255, 0.45)",
  },
  titleBtnDisabled: {
    opacity: 0.55,
    cursor: "not-allowed",
  },
  infoBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
    padding: "10px 12px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: `2px solid ${COLORS.primary_color_shade2}`,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade0} 0%, ${COLORS.white} 100%)`,
  },
  infoTitle: {
    margin: 0,
    fontSize: "13px",
    fontWeight: "800",
    color: COLORS.primary_color_shade9,
    lineHeight: 1.3,
  },
  infoHint: {
    margin: "2px 0 0",
    fontSize: "11px",
    fontWeight: "600",
    color: COLORS.primary_color_shade7,
    lineHeight: 1.4,
  },
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "5px 12px",
    borderRadius: "999px",
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
    background: COLORS.white,
    border: `2px solid ${COLORS.primary_color_shade3}`,
    boxShadow: `0 1px 3px ${COLORS.primary_color_shade2}55`,
  },
  section: {
    marginBottom: "14px",
    borderRadius: "8px",
    border: `2px solid ${COLORS.primary_color_shade3}`,
    overflow: "hidden",
    boxShadow: `0 1px 4px ${COLORS.primary_color_shade2}55`,
  },
  sectionHeader: {
    margin: 0,
    padding: "8px 12px",
    fontSize: "12px",
    fontWeight: "800",
    color: COLORS.white,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade4} 0%, ${COLORS.primary_color_shade6} 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    flexWrap: "wrap",
  },
  sectionHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  sectionMeta: {
    fontSize: "10px",
    fontWeight: "700",
    opacity: 0.92,
    textTransform: "none",
    letterSpacing: 0,
  },
  sectionHeaderActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  applyBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    border: "2px solid rgba(255, 255, 255, 0.85)",
    borderRadius: "6px",
    padding: "5px 12px",
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
    background: "rgba(255, 255, 255, 0.95)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
  },
  applyBtnDisabled: {
    opacity: 0.55,
    cursor: "not-allowed",
  },
  sectionBody: {
    padding: "10px 12px",
    background: COLORS.white,
  },
  sampleSection: {
    marginBottom: "10px",
  },
  sampleSectionHeader: {
    margin: 0,
    padding: "7px 12px",
    fontSize: "13px",
    fontWeight: "800",
    color: COLORS.white,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade4} 0%, ${COLORS.primary_color_shade6} 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "6px",
    flexWrap: "wrap",
  },
  sampleSectionMeta: {
    fontSize: "11px",
    fontWeight: "700",
    opacity: 0.92,
    textTransform: "none",
    letterSpacing: 0,
  },
  sampleSectionBody: {
    padding: "8px 12px",
    background: COLORS.white,
  },
  templateGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  templateCard: {
    minWidth: "112px",
    maxWidth: "180px",
    borderRadius: "6px",
    padding: "7px 10px",
    border: `2px solid ${COLORS.primary_color_shade3}`,
    background: COLORS.white,
    boxShadow: `0 1px 3px ${COLORS.primary_color_shade2}44`,
    transition: "all 0.2s ease",
    cursor: "pointer",
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  templateCardActive: {
    border: `2px solid ${COLORS.primary_color_shade7}`,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade0} 0%, ${COLORS.white} 100%)`,
    boxShadow: `0 2px 6px ${COLORS.primary_color_shade4}55`,
  },
  templateTick: {
    position: "absolute",
    top: "4px",
    right: "4px",
    width: "16px",
    height: "16px",
    borderRadius: "999px",
    background: COLORS.primary_color_shade7,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: `0 1px 4px ${COLORS.primary_color_shade5}66`,
  },
  templateName: {
    fontSize: "12px",
    fontWeight: "800",
    color: COLORS.primary_color_shade9,
    lineHeight: 1.3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    flex: 1,
    minWidth: 0,
    margin: 0,
    paddingRight: "12px",
  },
  sampleEmptyState: {
    padding: "8px 12px",
    borderRadius: "6px",
    background: COLORS.primary_color_shade0,
    fontSize: "12px",
    fontWeight: "700",
    color: COLORS.primary_color_shade7,
    border: `1px dashed ${COLORS.primary_color_shade3}`,
  },
  emptyState: {
    padding: "10px 12px",
    borderRadius: "8px",
    background: COLORS.primary_color_shade0,
    fontSize: "11px",
    fontWeight: "700",
    color: COLORS.primary_color_shade7,
    border: `2px dashed ${COLORS.primary_color_shade3}`,
  },
  previewHint: {
    fontSize: "10px",
    fontWeight: "700",
    color: COLORS.primary_color_shade6,
  },
  previewFrame: {
    position: "relative",
    borderRadius: "8px",
    overflow: "hidden",
    border: `2px solid ${COLORS.primary_color_shade3}`,
    background: COLORS.primary_color_shade0,
  },
  previewLoader: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(225, 245, 254, 0.92)",
    zIndex: 10,
  },
  generalWatermarkNote: {
    marginTop: "8px",
    padding: "8px 10px",
    borderRadius: "6px",
    background: COLORS.primary_color_shade0,
    border: `1px dashed ${COLORS.primary_color_shade3}`,
    fontSize: "11px",
    fontWeight: "600",
    color: COLORS.primary_color_shade8,
    lineHeight: 1.4,
  },
  settingsPanel: {
    padding: "8px",
    borderRadius: "8px",
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade0} 0%, ${COLORS.white} 100%)`,
    border: `1px solid ${COLORS.primary_color_shade2}`,
  },
  settingsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
    gap: "6px",
  },
  settingsCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "5px 10px",
    borderRadius: "8px",
    border: `1px solid ${COLORS.primary_color_shade2}`,
    background: COLORS.white,
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 3px rgba(2, 119, 189, 0.08)",
    minHeight: "30px",
  },
  settingsCardOn: {
    border: `1px solid ${COLORS.card_green}`,
    background: `linear-gradient(135deg, ${COLORS.green_light} 0%, ${COLORS.white} 100%)`,
    boxShadow: `0 2px 6px rgba(137, 190, 76, 0.25)`,
  },
  settingsCardOff: {
    border: `1px solid ${COLORS.grey3}`,
    background: COLORS.grey0,
    opacity: 0.88,
  },
  settingsLabel: {
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.leaf_green,
    lineHeight: 1.1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  settingsLabelOff: {
    color: COLORS.black6,
  },
  settingsBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "28px",
    padding: "3px 8px",
    borderRadius: "999px",
    fontSize: "9px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    flexShrink: 0,
  },
  settingsBadgeOn: {
    background: COLORS.green_dark,
    color: COLORS.white,
    border: `1px solid ${COLORS.leaf_green}`,
    boxShadow: "0 1px 3px rgba(51, 181, 54, 0.35)",
  },
  settingsBadgeOff: {
    background: COLORS.grey4,
    color: COLORS.white,
    border: `1px solid ${COLORS.grey5}`,
  },
  settingsSummary: {
    marginTop: "6px",
    padding: "5px 8px",
    borderRadius: "6px",
    background: COLORS.white,
    border: `1px dashed ${COLORS.primary_color_shade3}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    flexWrap: "wrap",
  },
  settingsSummaryCount: {
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
  },
};

const GENERAL_SETTING_FIELDS = [
  { key: "show_logo_watermark", label: "Logo Watermark" },
  { key: "show_text_watermark", label: "Text Watermark" },
  { key: "show_regno", label: "Regd No (Header)" },
  { key: "show_udise_no", label: "Udise Code (Header)" },
  { key: "show_establish_year", label: "Establish Year" },
  { key: "show_website", label: "Website" },
  { key: "show_contact1", label: "Contact 1" },
  { key: "show_contact2", label: "Contact 2" },
  { key: "show_email", label: "Email" },
  { key: "show_regno_bottom", label: "Regd No (Footer)" },
  { key: "show_udiseno_bottom", label: "Udise Code (Footer)" },
  { key: "show_address", label: "School Address" },
  { key: "show_digital_sign", label: "Principal Sign" },
  { key: "show_digital_sign2", label: "Exam Controller Sign" },
];

const isSettingOn = (value) => value === "1" || value === 1 || value === true;

const normalizeSettingValue = (value) => (isSettingOn(value) ? "1" : "0");

const buildGeneralSettingsSnapshot = (settings) => {
  if (!settings) {
    return {};
  }

  return GENERAL_SETTING_FIELDS.reduce((snapshot, field) => {
    snapshot[field.key] = normalizeSettingValue(settings[field.key]);
    return snapshot;
  }, {});
};

const GeneralSettingsPanel = memo(({ draftSettings, sampleId, onToggle }) => {
  if (!sampleId) {
    return (
      <div style={STYLES.emptyState}>Select a template to view general settings.</div>
    );
  }

  if (!draftSettings) {
    return (
      <div style={STYLES.emptyState}>Loading general settings for this template...</div>
    );
  }

  const enabledCount = GENERAL_SETTING_FIELDS.filter((field) =>
    isSettingOn(draftSettings[field.key])
  ).length;

  return (
    <div style={STYLES.settingsPanel}>
      <div style={STYLES.settingsGrid}>
        {GENERAL_SETTING_FIELDS.map((field) => {
          const enabled = isSettingOn(draftSettings[field.key]);
          return (
            <div
              key={field.key}
              role="button"
              tabIndex={0}
              onClick={() => onToggle(field.key)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  onToggle(field.key);
                }
              }}
              style={{
                ...STYLES.settingsCard,
                ...(enabled ? STYLES.settingsCardOn : STYLES.settingsCardOff),
              }}
              title={`Click to turn ${enabled ? "off" : "on"}`}
            >
              <span
                style={{
                  ...STYLES.settingsLabel,
                  ...(enabled ? {} : STYLES.settingsLabelOff),
                }}
                title={field.label}
              >
                {field.label}
              </span>
              <span
                style={{
                  ...STYLES.settingsBadge,
                  ...(enabled ? STYLES.settingsBadgeOn : STYLES.settingsBadgeOff),
                }}
              >
                {enabled ? "On" : "Off"}
              </span>
            </div>
          );
        })}
      </div>
      {isSettingOn(draftSettings.show_text_watermark) && draftSettings.text_watermark ? (
        <div style={STYLES.generalWatermarkNote}>
          <strong>Watermark text:</strong> {draftSettings.text_watermark}
        </div>
      ) : null}
      <div style={STYLES.settingsSummary}>
        <span style={STYLES.settingsSummaryCount}>
          {enabledCount} of {GENERAL_SETTING_FIELDS.length} options enabled
        </span>
        <span style={STYLES.infoHint}>Toggle options, then click Apply to save.</span>
      </div>
    </div>
  );
});

GeneralSettingsPanel.displayName = "GeneralSettingsPanel";

const cloneDataSettings = (settings) =>
  (settings || []).map((item) => ({ ...item }));

const getChangedDataSettings = (draftSettings, originalSettings) => {
  if (!draftSettings?.length || !originalSettings?.length) {
    return [];
  }

  return draftSettings.filter((draftItem) => {
    const originalItem = originalSettings.find(
      (item) => item.option_id === draftItem.option_id
    );

    if (!originalItem) {
      return false;
    }

    return (
      normalizeSettingValue(draftItem.default_status) !==
      normalizeSettingValue(originalItem.default_status)
    );
  });
};

const DataSelectionSettingsPanel = memo(({ draftSettings, sampleId, onToggle }) => {
  if (!sampleId) {
    return (
      <div style={STYLES.emptyState}>Select a template to view student information.</div>
    );
  }

  if (!draftSettings) {
    return (
      <div style={STYLES.emptyState}>Loading student information for this template...</div>
    );
  }

  if (draftSettings.length === 0) {
    return (
      <div style={STYLES.emptyState}>No data fields configured for this template.</div>
    );
  }

  const enabledCount = draftSettings.filter((item) =>
    isSettingOn(item.default_status)
  ).length;

  return (
    <div style={STYLES.settingsPanel}>
      <div style={STYLES.settingsGrid}>
        {draftSettings.map((item) => {
          const enabled = isSettingOn(item.default_status);

          return (
            <div
              key={item.option_id}
              role="button"
              tabIndex={0}
              onClick={() => onToggle(item.option_id)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  onToggle(item.option_id);
                }
              }}
              style={{
                ...STYLES.settingsCard,
                ...(enabled ? STYLES.settingsCardOn : STYLES.settingsCardOff),
              }}
              title={`Click to turn ${enabled ? "off" : "on"}`}
            >
              <span
                style={{
                  ...STYLES.settingsLabel,
                  ...(enabled ? {} : STYLES.settingsLabelOff),
                }}
                title={item.field_options}
              >
                {item.field_options}
              </span>
              <span
                style={{
                  ...STYLES.settingsBadge,
                  ...(enabled ? STYLES.settingsBadgeOn : STYLES.settingsBadgeOff),
                }}
              >
                {enabled ? "On" : "Off"}
              </span>
            </div>
          );
        })}
      </div>
      <div style={STYLES.settingsSummary}>
        <span style={STYLES.settingsSummaryCount}>
          {enabledCount} of {draftSettings.length} fields enabled
        </span>
        <span style={STYLES.infoHint}>Toggle fields, then click Apply to save.</span>
      </div>
    </div>
  );
});

DataSelectionSettingsPanel.displayName = "DataSelectionSettingsPanel";

function PageHeader() {
  return (
    <div
      className="content-header"
      style={{ background: COLORS.primary_color_shade5 }}
    >
      <div className="leftside-content-header">
        <ul className="breadcrumbs">
          <li>
            <i
              className="fa fa-home"
              aria-hidden="true"
              style={{ color: COLORS.white }}
            />
            <span style={{ color: COLORS.white }}>Exam Result</span>
          </li>
        </ul>
      </div>
      <div className="rightside-content-header">
        <BackButton />
      </div>
    </div>
  );
}

const TemplateCard = memo(({ item, isActive, onSelect }) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onSelect}
    onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") {
        onSelect();
      }
    }}
    style={{
      ...STYLES.templateCard,
      ...(isActive ? STYLES.templateCardActive : {}),
    }}
  >
    {isActive ? (
      <div style={STYLES.templateTick}>
        <i className="fa fa-check" style={{ color: "#fff", fontSize: "9px" }} />
      </div>
    ) : null}
    <p style={STYLES.templateName} title={item.sample_name}>
      {item.sample_name}
    </p>
  </div>
));

TemplateCard.displayName = "TemplateCard";

function buildPreviewUrl({
  fileDirectory,
  fileName,
  selectedSampleId,
  selectionType,
  mSelectedStudent,
  classId,
  sectionId,
  colorOptionId,
  examId,
  examName,
  preview = false,
}) {
  if (!fileDirectory || !fileName || !selectedSampleId) {
    return "";
  }

  let session_id = "";
  const mStudentIds = [];

  if (selectionType === "student" && mSelectedStudent.length > 0) {
    mSelectedStudent.forEach((element, index) => {
      mStudentIds[index] = element.student_enrollment_no;
      session_id = element.session_id;
    });
  }

  //Created By Cursor — encode params so ExamResult.php receives valid student_ids JSON
  const normalizedSectionId =
    !sectionId || sectionId === "null" ? "No" : sectionId;
  let url =
    `${process.env.REACT_APP_SERVER_NAME}${fileDirectory}${fileName}` +
    `?student_ids=${encodeURIComponent(JSON.stringify(mStudentIds))}` +
    `&class_id=${encodeURIComponent(classId || "")}` +
    `&section_id=${encodeURIComponent(normalizedSectionId)}` +
    `&session_id=${encodeURIComponent(session_id || "")}` +
    `&sample_id=${encodeURIComponent(selectedSampleId || "")}` +
    `&selection_type=${encodeURIComponent(selectionType || "student")}` +
    `&system_code=${encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE || "")}` +
    `&color_option_id=${encodeURIComponent(colorOptionId || "")}` +
    `&exam_id=${encodeURIComponent(examId || "")}` +
    `&exam_name=${encodeURIComponent(examName || "")}` +
    `&school_code=${encodeURIComponent(SessionManager.getSchoolCode() || "")}`;

  if (preview) {
    url += "&preview=1";
  }

  return url;
}

function applySampleSelection(samples, position, setters) {
  if (!samples?.length) {
    return;
  }

  const sample = samples[position];
  const colorOptions = sample.color_options || [];

  setters.setFileName(sample.file_name);
  setters.setFileDirectory(sample.file_directory);
  setters.setSelectedSampleId(sample.sample_id);
  setters.setSelectedSamplePosition(position);
  setters.setColorOptionId(
    colorOptions.length ? colorOptions[0].color_option_id : ""
  );
}

async function fetchPrintableGeneralSettings(sampleId) {
  if (!sampleId) {
    return [];
  }

  const response = await axios.get(`${API_BASE()}getPrintableGeneralSettings.php`, {
    params: {
      school_code: SessionManager.getSchoolCode(),
      sample_id: sampleId,
    },
  });

  const payload = response.data;
  if (payload.api_status === "OK") {
    return payload.data || [];
  }

  myToast.notify_warning(payload.api_remark || "Unable to load printable settings.");
  return [];
}

async function savePrintableGeneralSettings(sampleId, settingsSnapshot) {
  const staff = SessionManager.getStaffDetails();
  const session = SessionManager.getCurrentSession();
  const params = new URLSearchParams();

  params.append("staff_id", staff.staff_id);
  params.append("school_code", SessionManager.getSchoolCode());
  params.append("sample_id", sampleId);
  params.append("session_id", session[0].session_id);
  params.append("general_settings", JSON.stringify(settingsSnapshot));

  const response = await axios.post(
    `${API_BASE()}updatePrintableGeneralSettings.php`,
    params
  );

  return response.data;
}

async function fetchPrintableSampleDataSettings(sampleId) {
  if (!sampleId) {
    return [];
  }

  const response = await axios.get(`${API_BASE()}getPrintableSampleDataSettings.php`, {
    params: {
      school_code: SessionManager.getSchoolCode(),
      sample_id: sampleId,
    },
  });

  const payload = response.data;
  if (payload.api_status === "OK") {
    return payload.data || [];
  }

  myToast.notify_warning(payload.api_remark || "Unable to load student information.");
  return [];
}

async function savePrintableDataSetting(item) {
  const staff = SessionManager.getStaffDetails();

  const response = await axios.get(`${API_BASE()}updatePrintableSampleDataSettings.php`, {
    params: {
      staff_id: staff.staff_id,
      school_code: SessionManager.getSchoolCode(),
      sample_id: item.sample_id,
      option_id: item.option_id,
      field_options: item.field_options,
    },
  });

  return response.data;
}

const PrintableDocsResult = () => {
  const { document_type } = useParams();

  const [loggedIn] = useState(() => localStorage.getItem("token") !== null);
  const [loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [isOpenSelectExam, setIsOpenSelectExam] = useState(false);
  const [isOpenSettings, setIsOpenSettings] = useState(false);
  const [showPrintable, setShowPrintable] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [selectedSampleId, setSelectedSampleId] = useState("");
  const [selectedSamplePosition, setSelectedSamplePosition] = useState(0);
  const [selectionType, setSelectionType] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileDirectory, setFileDirectory] = useState("");
  const [colorOptionId, setColorOptionId] = useState("");
  const [examId, setExamId] = useState("");
  const [examName, setExamName] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [generalSettings, setGeneralSettings] = useState([]);
  const [draftGeneralSettings, setDraftGeneralSettings] = useState(null);
  const [originalGeneralSettings, setOriginalGeneralSettings] = useState(null);
  const [isApplyingGeneralSettings, setIsApplyingGeneralSettings] = useState(false);
  const [dataSelectionSettings, setDataSelectionSettings] = useState([]);
  const [draftDataSelectionSettings, setDraftDataSelectionSettings] = useState(null);
  const [originalDataSelectionSettings, setOriginalDataSelectionSettings] = useState(null);
  const [isApplyingDataSelection, setIsApplyingDataSelection] = useState(false);
  const [iframeHeight, setIframeHeight] = useState("300px");
  const fileUrlRef = useRef("");

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.iframeHeight) {
        setIframeHeight(`${event.data.iframeHeight}px`);
      }
    };

    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (fileUrl) {
      setIframeHeight("300px");
    }
  }, [fileUrl]);

  useEffect(() => {
    if (!document_type) {
      return;
    }

    let isMounted = true;
    setLoading(true);

    axios
      .get(`${API_BASE()}getPrintableSample.php`, {
      params: {
          school_code: SessionManager.getSchoolCode(),
          document_type,
        },
      })
      .then((res) => res.data)
    .then((response) => {
        if (!isMounted) {
          return;
        }

      setLoading(false);

        if (response.api_status === "OK") {
          const samples = response.data || [];
          setMPrintableSamples(samples);
          applySampleSelection(samples, 0, {
            setFileName,
            setFileDirectory,
            setSelectedSampleId,
            setSelectedSamplePosition,
            setColorOptionId,
          });
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        if (!isMounted) {
          return;
        }
        setLoading(false);
        console.error("Error fetching printable samples:", error);
      });

    return () => {
      isMounted = false;
    };
  }, [document_type]);

  const loadGeneralSettings = useCallback(async (sampleId) => {
    try {
      const settings = await fetchPrintableGeneralSettings(sampleId);
      setGeneralSettings(settings);
      const activeSettings = settings?.[0] || null;
      setDraftGeneralSettings(activeSettings ? { ...activeSettings } : null);
      setOriginalGeneralSettings(activeSettings ? { ...activeSettings } : null);
    } catch (error) {
      console.error("Error fetching printable general settings:", error);
      setDraftGeneralSettings(null);
      setOriginalGeneralSettings(null);
    }
  }, []);

  const loadDataSelectionSettings = useCallback(async (sampleId) => {
    try {
      const settings = await fetchPrintableSampleDataSettings(sampleId);
      setDataSelectionSettings(settings);
      setDraftDataSelectionSettings(cloneDataSettings(settings));
      setOriginalDataSelectionSettings(cloneDataSettings(settings));
    } catch (error) {
      console.error("Error fetching printable data selection settings:", error);
      setDataSelectionSettings([]);
      setDraftDataSelectionSettings(null);
      setOriginalDataSelectionSettings(null);
    }
  }, []);

  useEffect(() => {
    if (!selectedSampleId) {
      setGeneralSettings([]);
      setDraftGeneralSettings(null);
      setOriginalGeneralSettings(null);
      setDataSelectionSettings([]);
      setDraftDataSelectionSettings(null);
      setOriginalDataSelectionSettings(null);
      return;
    }

    loadGeneralSettings(selectedSampleId);
    loadDataSelectionSettings(selectedSampleId);
  }, [selectedSampleId, loadGeneralSettings, loadDataSelectionSettings]);

  const selectedSampleName = useMemo(
    () => mPrintableSamples[selectedSamplePosition]?.sample_name || "",
    [mPrintableSamples, selectedSamplePosition]
  );

  const hasGeneralSettingsChanges = useMemo(() => {
    if (!draftGeneralSettings || !originalGeneralSettings) {
      return false;
    }

    const draftSnapshot = buildGeneralSettingsSnapshot(draftGeneralSettings);
    const originalSnapshot = buildGeneralSettingsSnapshot(originalGeneralSettings);

    return GENERAL_SETTING_FIELDS.some(
      (field) => draftSnapshot[field.key] !== originalSnapshot[field.key]
    );
  }, [draftGeneralSettings, originalGeneralSettings]);

  const hasDataSelectionChanges = useMemo(() => {
    if (!draftDataSelectionSettings || !originalDataSelectionSettings) {
      return false;
    }

    return getChangedDataSettings(
      draftDataSelectionSettings,
      originalDataSelectionSettings
    ).length > 0;
  }, [draftDataSelectionSettings, originalDataSelectionSettings]);

  const handleToggleGeneralSetting = useCallback((fieldKey) => {
    setDraftGeneralSettings((prev) => {
      if (!prev) {
        return prev;
      }

      return {
        ...prev,
        [fieldKey]: isSettingOn(prev[fieldKey]) ? "0" : "1",
      };
    });
  }, []);

  const handleToggleDataSelectionSetting = useCallback((optionId) => {
    setDraftDataSelectionSettings((prev) => {
      if (!prev) {
        return prev;
      }

      return prev.map((item) =>
        item.option_id === optionId
          ? {
              ...item,
              default_status: isSettingOn(item.default_status) ? "0" : "1",
            }
          : item
      );
    });
  }, []);

  useEffect(() => {
    if (
      selectionType !== "student" ||
      mSelectedStudent.length === 0 ||
      !fileDirectory ||
      !fileName ||
      !selectedSampleId
    ) {
      return;
    }

    const nextUrl = buildPreviewUrl({
    fileDirectory,
    fileName,
    selectedSampleId,
    selectionType,
    mSelectedStudent,
    classId,
    sectionId,
      colorOptionId,
      examId,
      examName,
    });

    if (!nextUrl || nextUrl === fileUrlRef.current) {
      return;
    }

    fileUrlRef.current = nextUrl;
    console.log("FILE_URL", nextUrl);
    setFileUrl(nextUrl);
    setShowPrintable(true);
  }, [
    mSelectedStudent,
    selectionType,
    fileDirectory,
    fileName,
    selectedSampleId,
    colorOptionId,
    examId,
    examName,
    classId,
    sectionId,
    generalSettings,
    dataSelectionSettings,
  ]);

  const changeSample = useCallback(
    (position) => {
      applySampleSelection(mPrintableSamples, position, {
        setFileName,
        setFileDirectory,
        setSelectedSampleId,
        setSelectedSamplePosition,
        setColorOptionId,
      });
    },
    [mPrintableSamples]
  );

  const handleCloseSelectStudent = useCallback(() => {
    setIsOpenSelectStudent(false);
  }, []);

  const handleSelectedStudent = useCallback((selectedStudents) => {
    const students = selectedStudents || [];

    setIsOpenSelectStudent(false);
    setMSelectedStudent(students);
    setSelectionType("student");

    if (students.length > 0) {
      const firstStudent = students[0];
      if (firstStudent.class_id) {
        setClassId(firstStudent.class_id);
      }
      if (firstStudent.section_id) {
        setSectionId(firstStudent.section_id);
      }
    }
  }, []);

  const handleCloseSelectExam = useCallback(() => {
    setIsOpenSelectExam(false);
  }, []);

  const handleSelectedExam = useCallback(
    (exam_id, exam_name) => {
    setExamId(exam_id);
    setExamName(exam_name);
    handleCloseSelectExam();
    },
    [handleCloseSelectExam]
  );

  const selectStudent = useCallback(() => {
    if (!examId) {
      myToast.notify_warning("Please select an exam first.");
      return;
    }
    setIsOpenSelectStudent(true);
  }, [examId]);

  const selectExam = useCallback(() => {
    setIsOpenSelectExam(true);
  }, []);

  const handleIframeLoad = useCallback(() => {
    setShowPrintable(false);
  }, []);

  const previewUrl = useMemo(
    () =>
      buildPreviewUrl({
        fileDirectory,
        fileName,
        selectedSampleId,
        selectionType,
        mSelectedStudent,
        classId,
        sectionId,
        colorOptionId,
        examId,
        examName,
        preview: true,
      }),
    [
      fileDirectory,
      fileName,
      selectedSampleId,
      selectionType,
      mSelectedStudent,
      classId,
      sectionId,
      colorOptionId,
      examId,
      examName,
    ]
  );

  const openSettings = useCallback(() => {
    if (!selectedSampleId) {
      myToast.notify_warning("Please select a template first.");
      return;
    }
    setIsOpenSettings(true);
  }, [selectedSampleId]);

  const refreshMainPreview = useCallback(() => {
    if (
      selectionType !== "student" ||
      mSelectedStudent.length === 0 ||
      !fileDirectory ||
      !fileName ||
      !selectedSampleId
    ) {
      return;
    }

    const nextUrl = `${buildPreviewUrl({
      fileDirectory,
      fileName,
      selectedSampleId,
      selectionType,
      mSelectedStudent,
      classId,
      sectionId,
      colorOptionId,
      examId,
      examName,
    })}&_t=${Date.now()}`;

    fileUrlRef.current = nextUrl;
    console.log("FILE_URL", nextUrl);
    setFileUrl(nextUrl);
    setShowPrintable(true);
  }, [
    selectionType,
    mSelectedStudent,
    fileDirectory,
    fileName,
    selectedSampleId,
    classId,
    sectionId,
    colorOptionId,
    examId,
    examName,
  ]);

  const handleApplyGeneralSettings = useCallback(async () => {
    if (!selectedSampleId || !draftGeneralSettings) {
      return;
    }

    if (!hasGeneralSettingsChanges) {
      myToast.notify_info("No changes to apply.");
      return;
    }

    setIsApplyingGeneralSettings(true);

    try {
      const payload = buildGeneralSettingsSnapshot(draftGeneralSettings);
      const response = await savePrintableGeneralSettings(selectedSampleId, payload);

      if (response.api_status === "OK") {
        myToast.notify_success("General settings updated.");
        await loadGeneralSettings(selectedSampleId);
        refreshMainPreview();
      } else {
        myToast.notify_warning(response.api_remark || "Unable to update general settings.");
      }
    } catch (error) {
      console.error("Error updating printable general settings:", error);
      myToast.notify_error("Something went wrong while saving settings.");
    } finally {
      setIsApplyingGeneralSettings(false);
    }
  }, [
    selectedSampleId,
    draftGeneralSettings,
    hasGeneralSettingsChanges,
    loadGeneralSettings,
    refreshMainPreview,
  ]);

  const handleApplyDataSelectionSettings = useCallback(async () => {
    if (!selectedSampleId || !draftDataSelectionSettings) {
      return;
    }

    const changedSettings = getChangedDataSettings(
      draftDataSelectionSettings,
      originalDataSelectionSettings
    );

    if (changedSettings.length === 0) {
      myToast.notify_info("No changes to apply.");
      return;
    }

    setIsApplyingDataSelection(true);

    try {
      for (const item of changedSettings) {
        const response = await savePrintableDataSetting(item);

        if (response.api_status !== "OK") {
          myToast.notify_warning(
            response.api_remark || `Unable to update ${item.field_options}.`
          );
          await loadDataSelectionSettings(selectedSampleId);
          return;
        }
      }

      myToast.notify_success("Student information updated.");
      await loadDataSelectionSettings(selectedSampleId);
      refreshMainPreview();
    } catch (error) {
      console.error("Error updating printable data selection settings:", error);
      myToast.notify_error("Something went wrong while saving student information.");
    } finally {
      setIsApplyingDataSelection(false);
    }
  }, [
    selectedSampleId,
    draftDataSelectionSettings,
    originalDataSelectionSettings,
    loadDataSelectionSettings,
    refreshMainPreview,
  ]);

  const handleCloseSettings = useCallback(() => {
    setIsOpenSettings(false);
    if (selectedSampleId) {
      loadGeneralSettings(selectedSampleId);
      loadDataSelectionSettings(selectedSampleId);
    }
    refreshMainPreview();
  }, [
    refreshMainPreview,
    selectedSampleId,
    loadGeneralSettings,
    loadDataSelectionSettings,
  ]);

  const handleSettingsDone = handleCloseSettings;

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <div className="content" style={{ background: COLORS.white }}>
      <PageHeader />

      <div
        className="animated fadeInUp bg_page_white_rounded box_shadow"
        style={PANEL_STYLE}
      >
        <div style={PAGE_TITLE_BAR_STYLE}>
          <div>
            <h3 style={PAGE_TITLE_STYLE}>
              <i className="fa fa-file-text-o" aria-hidden="true" style={{ color: "#fff" }} />
                Exam Result
            </h3>
            <p style={PAGE_SUBTITLE_STYLE}>
              Generate exam results for selected exam and students
            </p>
            </div>

          <div style={STYLES.titleActions}>
            <button type="button" style={STYLES.titleBtn} onClick={selectExam}>
              <i className="fa fa-calendar-check-o" aria-hidden="true" />
                {examName ? "Change Exam" : "Select Exam"}
            </button>
            <button
              type="button"
              style={{
                ...STYLES.titleBtn,
                ...STYLES.titleBtnPrimary,
                ...(!examId ? STYLES.titleBtnDisabled : {}),
              }}
              onClick={selectStudent}
              disabled={!examId}
            >
              <i className="fa fa-users" aria-hidden="true" />
                {mSelectedStudent.length > 0
                  ? `Students (${mSelectedStudent.length})`
                  : "Select Students"}
            </button>
            <button type="button" style={STYLES.titleBtn} onClick={openSettings}>
              <i className="fa fa-cog" aria-hidden="true" />
              Settings
            </button>
          </div>
        </div>

        <div style={PANEL_BODY_STYLE}>
          <div style={STYLES.infoBar}>
          <div>
              <p style={STYLES.infoTitle}>
                {examName ? `Exam Result – ${examName}` : "Exam Result – No exam selected"}
              </p>
              <p style={STYLES.infoHint}>
              {examName
                ? "Preview and print exam results for the selected exam."
                : "Please select an exam to enable exam result preview."}
              </p>
            </div>
            {mSelectedStudent.length > 0 ? (
              <span style={STYLES.countBadge}>
                <i className="fa fa-user-circle" aria-hidden="true" />
                {mSelectedStudent.length} student
                {mSelectedStudent.length > 1 ? "s" : ""} selected
              </span>
            ) : null}
        </div>

          <section style={{ ...STYLES.section, ...STYLES.sampleSection }}>
            <div style={STYLES.sampleSectionHeader}>
              <span style={STYLES.sectionHeaderLeft}>
                <i className="fa fa-clone" aria-hidden="true" />
                Sample List
              </span>
              <span style={STYLES.sampleSectionMeta}>
                {mPrintableSamples.length > 0
                  ? `${mPrintableSamples.length} template${mPrintableSamples.length > 1 ? "s" : ""}`
                  : "None"}
              </span>
          </div>
            <div style={STYLES.sampleSectionBody}>
              {mPrintableSamples.length > 0 ? (
                <div style={STYLES.templateGrid}>
                  {mPrintableSamples.map((item, index) => (
                    <TemplateCard
                      key={item.sample_id || index}
                      item={item}
                      isActive={selectedSamplePosition === index}
                      onSelect={() => changeSample(index)}
                    />
                  ))}
            </div>
              ) : (
                <div style={STYLES.sampleEmptyState}>
                  No exam result templates configured.
                        </div>
                      )}
                      </div>
          </section>

          <section style={STYLES.section}>
            <div style={STYLES.sectionHeader}>
              <span style={STYLES.sectionHeaderLeft}>
                <i className="fa fa-sliders" aria-hidden="true" />
                General Settings
              </span>
              <div style={STYLES.sectionHeaderActions}>
                <button
                  type="button"
                        style={{
                    ...STYLES.applyBtn,
                    ...(!hasGeneralSettingsChanges || isApplyingGeneralSettings || !selectedSampleId
                      ? STYLES.applyBtnDisabled
                      : {}),
                  }}
                  onClick={handleApplyGeneralSettings}
                  disabled={
                    !hasGeneralSettingsChanges ||
                    isApplyingGeneralSettings ||
                    !selectedSampleId
                  }
                >
                  <i className="fa fa-check" aria-hidden="true" />
                  {isApplyingGeneralSettings ? "Applying..." : "Apply"}
                </button>
                <span style={STYLES.sectionMeta}>
                  {selectedSampleName || "No template selected"}
                </span>
                      </div>
                    </div>
            <div style={STYLES.sectionBody}>
              <GeneralSettingsPanel
                draftSettings={draftGeneralSettings}
                sampleId={selectedSampleId}
                onToggle={handleToggleGeneralSetting}
              />
                  </div>
          </section>

          <section style={STYLES.section}>
            <div style={STYLES.sectionHeader}>
              <span style={STYLES.sectionHeaderLeft}>
                <i className="fa fa-address-card" aria-hidden="true" />
                Student Information
              </span>
              <div style={STYLES.sectionHeaderActions}>
                <button
                  type="button"
                  style={{
                    ...STYLES.applyBtn,
                    ...(!hasDataSelectionChanges ||
                    isApplyingDataSelection ||
                    !selectedSampleId
                      ? STYLES.applyBtnDisabled
                      : {}),
                  }}
                  onClick={handleApplyDataSelectionSettings}
                  disabled={
                    !hasDataSelectionChanges ||
                    isApplyingDataSelection ||
                    !selectedSampleId
                  }
                >
                  <i className="fa fa-check" aria-hidden="true" />
                  {isApplyingDataSelection ? "Applying..." : "Apply"}
                </button>
                <span style={STYLES.sectionMeta}>
                  {selectedSampleName || "No template selected"}
                </span>
                </div>
              </div>
            <div style={STYLES.sectionBody}>
              <DataSelectionSettingsPanel
                draftSettings={draftDataSelectionSettings}
                sampleId={selectedSampleId}
                onToggle={handleToggleDataSelectionSetting}
              />
          </div>
          </section>

          <section style={STYLES.section}>
            <div style={STYLES.sectionHeader}>
              <span style={STYLES.sectionHeaderLeft}>
                <i className="fa fa-eye" aria-hidden="true" />
                Preview
              </span>
              {!fileUrl ? (
                <span style={STYLES.previewHint}>
                Select exam, students and template to load preview
              </span>
              ) : null}
          </div>
            <div style={STYLES.sectionBody}>
              <div style={STYLES.previewFrame}>
                {showPrintable ? (
                  <div style={STYLES.previewLoader}>
                <MyLoader />
              </div>
                ) : null}
                {fileUrl ? (
            <Iframe
              url={fileUrl}
              width="100%"
                    height={iframeHeight}
                    overflow="hidden"
              id="iFrameStudentId"
              display="initial"
              position="relative"
                    scrolling="no"
                    style={{ border: "none", overflow: "hidden" }}
              onLoad={handleIframeLoad}
            />
                ) : (
                  <div style={STYLES.emptyState}>
                    Select exam, students and template to load preview.
          </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>

      {isOpenSelectStudent ? (
        <MdlSelectMultipleStudent
          actionClose={handleCloseSelectStudent}
          actionHandleSelected={handleSelectedStudent}
        />
      ) : null}

      {isOpenSelectExam ? (
        <MdlSelectExam
          action_close={handleCloseSelectExam}
          action_select={handleSelectedExam}
        />
      ) : null}

      {isOpenSettings ? (
        <MdlPrintableSettings
          sample_id={selectedSampleId}
          color_option_id={colorOptionId}
          actionClose={handleCloseSettings}
          actionDone={handleSettingsDone}
          file_url={previewUrl}
          title="Exam Result Design Settings"
        />
      ) : null}
    </div>
  );
};

export default memo(PrintableDocsResult);
